import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { ArrivalStatus } from '@/coreDomainsModule/entities/arrival';

/**
 *  発注ステータスから入荷ステータスへの変換を行うサービス
 */
export class ArrivalStatusService {
  /**
   * 発注ステータスから入荷ステータスへの変換を行う
   * @param orderStatus - 発注ステータス
   */
  static OrderStatusToArrivalStatus(orderStatus: OrderStatus): ArrivalStatus {
    switch (orderStatus) {
      case OrderStatus.ApprovedAwaitingDeliveryDate:
      case OrderStatus.DeliveryDateConfirmed:
      case OrderStatus.QuantityConfirmed:
      case OrderStatus.PartialDelivery:
      case OrderStatus.Confirmed:
      case OrderStatus.DeliveryDelayed:
        return ArrivalStatus.Unpaid;
      case OrderStatus.ApprovalRequested:
        return ArrivalStatus.ApprovalRequested;
      case OrderStatus.Recommended:
        return ArrivalStatus.Recommended;
      default:
        return ArrivalStatus.Nothing;
    }
  }

  /**
   * 表示優先度の数値に変換する
   * @param arrivalStatus - 入荷ステータス
   */
  static ArrivalStatusToPriority(arrivalStatus: ArrivalStatus): number {
    switch (arrivalStatus) {
      case ArrivalStatus.Unpaid:
        return 3;
      case ArrivalStatus.ApprovalRequested:
        return 2;
      case ArrivalStatus.Recommended:
        return 1;
      default:
        return 0;
    }
  }
}
